export default "__VITE_ASSET__urIs_Uqv__"